// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"34759835","229":"fed9f1f4","252":"3cbbb574","305":"05563b8c","316":"9b9e5683","346":"f0c00863","453":"8ac25cd2","477":"9b4d1869","504":"46aa3671","554":"c10ccac4","578":"cd7554fb","638":"bbe68e00","742":"8e5bd890","922":"b1695249","964":"89171e7f"}[chunkId] + ".chunk.js";
};